import { useState } from "react"
// import Select, { weightsSelectOptions } from "./Select"
import { useSelector } from "react-redux"
import Slider from "rc-slider"
import "rc-slider/assets/index.css"
import { FormattedMessage } from "react-intl"

const weightOptions = [
  {
    key: "hard_skills_weight",
    label: "common.hardSkills",
  },
  {
    key: "soft_skills_weight",
    label: "common.softSkills",
  },
  {
    key: "education_weight",
    label: "common.education",
  },
  {
    key: "experience_weight",
    label: "common.experience",
  },
];

const sliderStyles = {
  track: {
    height: 7,
    background: 'var(--strong)',
    top: 4,
  },
  rail: {
    background: `linear-gradient(to right, var(--white), var(--warning-orange-transparency))`,
    height: 7,
    top: 4,
    borderRadius: 0,
  },
};

const Weights = ({ action, weightsData, setWeightsData, showWeights = false }) => {
  const { weights: storedWeights } = useSelector((state) => state.jobs)
  const [weightsChanged, setWeightsChanged] = useState(false)

  const onChange = (key, newValue) => {
    setWeightsChanged(true)

    setWeightsData((weightsData) => ({
      ...weightsData,
      [key]: Number(newValue.toFixed(3))
    }));
  }

  const handleReset = () => {
    setWeightsData({ ...storedWeights })
    setWeightsChanged(false)
  }

  return (
    <div className="weights">

      {showWeights && (
        <div className="weights__sliders">
          <p className="weights__title">
            <FormattedMessage id="message.moveSlidersForMatching" />{" "}
          </p>

          <div className="weight">
            <div />

            <div className="weight__labels">
              <span className="weight__label p">
                <FormattedMessage id="common.less" />
              </span>
              <span className="weight__label p">
                <FormattedMessage id="common.more" />
              </span>
            </div>
          </div>

          {weightOptions.map((weight, i) => {
            // Workaround for older weights data that was based on percentages
            const value = weightsData[weight.key] < 1
              ? Math.floor(weightsData[weight.key] * 10)
              : weightsData[weight.key];

            return (
              <div key={`Weight - ${i}`} className="weight">
                <p className="weight__label p">
                  <FormattedMessage id={weight.label} />
                </p>

                <div className="weight__slider">
                  <span>{"1"}</span>
                  <Slider
                    dots
                    className="weight__slider--controller"
                    onChange={(nextValues) => onChange(weight.key, nextValues)}
                    onChangeComplete={(v) => onChange(weight.key, v)}
                    min={1}
                    max={10}
                    value={value}
                    step={1}
                    styles={sliderStyles}
                  />
                  <span className="weight-value">{value}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="weights__buttons">
        {action}
        {weightsChanged && (
          <button
            onClick={handleReset}
            className="btn senary btn--small"
          >
            <FormattedMessage id="common.reset" />
          </button>
        )}
      </div>
    </div>
  )
}

export default Weights
